import {
  ELeaseTermType,
  IBargainTermsSchema,
} from '../../../../../repositories/monolith-python/entities/offer/BargainTermsSchema';
import { IOfferState } from '../../../../reducers';

// костыли, чтобы хрупкий бэкенд не ломался
export const mapBargainTerms = (offer: IOfferState): IBargainTermsSchema | null => {
  const { bargainTerms } = offer;

  if (!bargainTerms) {
    return null;
  }

  const leaseTermType = bargainTerms.leaseTermType as ELeaseTermType;

  let {
    clientFee,
    agentFee,
    deposit,
    agentBonus,
    ...restBargainTerms // eslint-disable-line prefer-const
  } = bargainTerms;

  // Питон не любит null в этих полях
  if (!clientFee) {
    clientFee = 0;
  }

  if (!agentFee) {
    agentFee = 0;
  }

  if (!deposit) {
    deposit = 0;
  }

  if (agentBonus) {
    if (!agentBonus.paymentType || agentBonus.value === null) {
      agentBonus = null;
    }
  }

  return {
    ...restBargainTerms,
    leaseTermType,
    clientFee,
    agentFee,
    deposit,
    agentBonus,
  };
};
